<template>
  <footer class="footer-modern">
    <v-container>
      <v-row class="pb-8">
        <!-- Logo and Description -->
        <v-col cols="12" md="4" class="mb-8 mb-md-0">
          <div class="footer-logo mb-4">
            <div class="footer-logo-icon">
              <div class="footer-hex"></div>
            </div>
            <div class="footer-logo-text">
              <div class="logo-wrenzo-footer">Wrenzo</div>
              <div class="logo-suite-footer">SUITE</div>
            </div>
          </div>
          <p class="footer-description">
            The all-in-one platform built for independent auto shops — scheduling, messaging,
            invoicing, and automated reminders that keep customers coming back.
          </p>
        </v-col>

        <!-- Company -->
        <v-col cols="12" sm="4" md="2" class="mb-8 mb-md-0">
          <h4 class="footer-heading mb-4">Company</h4>
          <ul class="footer-links">
            <li><router-link to="/why">Why Wrenzo Suite</router-link></li>
            <li><router-link to="/features">Features</router-link></li>
            <li><router-link to="/about">About Us</router-link></li>
            <li><router-link to="/blog">Blog</router-link></li>
          </ul>
        </v-col>

        <!-- Support -->
        <v-col cols="12" sm="4" md="2" class="mb-8 mb-md-0">
          <h4 class="footer-heading mb-4">Support</h4>
          <ul class="footer-links">
            <li><router-link to="/documentation">Documentation</router-link></li>
            <li><router-link to="/help">Help Center</router-link></li>
            <li><router-link to="/contact">Contact Us</router-link></li>
            <li><router-link to="/demo">Request Demo</router-link></li>
            <li><router-link to="/login">Client Portal</router-link></li>
          </ul>
        </v-col>

        <!-- Legal -->
        <v-col cols="12" sm="4" md="2" class="mb-8 mb-md-0">
          <h4 class="footer-heading mb-4">Legal</h4>
          <ul class="footer-links">
            <li><router-link to="/privacy">Privacy Policy</router-link></li>
            <li><router-link to="/terms">Terms of Service</router-link></li>
            <li><router-link to="/cookies">Cookie Policy</router-link></li>
            <li><router-link to="/security">Security</router-link></li>
          </ul>
        </v-col>

        <!-- Contact -->
        <v-col cols="12" sm="6" md="2">
          <h4 class="footer-heading mb-4">Contact</h4>
          <div class="footer-contact">
            <div class="contact-item mb-2">
              <v-icon small color="#FF6B7A" class="mr-2">mdi-email</v-icon>
              <a href="mailto:hello@wrenzosuite.com">ricosevere@codeforgedev.com</a>
            </div>
            <div class="contact-item mb-2">
              <v-icon small color="#FF6B7A" class="mr-2">mdi-phone</v-icon>
              <a href="tel:8005550199">(339) 241-8725</a>
            </div>
            <div class="contact-item">
              <v-icon small color="#FF6B7A" class="mr-2">mdi-map-marker</v-icon>
              <span>United States</span>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-divider class="mb-6" style="border-color: rgba(255,255,255,0.09) !important;"></v-divider>

      <div class="footer-bottom">
        <p class="copyright mb-0">
          © {{ currentYear }} Wrenzo Suite. All rights reserved.
        </p>
        <div class="footer-meta">
          <span class="meta-item">Made in USA</span>
          <span class="meta-divider">•</span>
          <span class="meta-item">Built for Shops</span>
        </div>
      </div>
    </v-container>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;600;700;800&display=swap');

.footer-modern {
  --crimson: #D6293E;
  --crimson-light: #FF6B7A;
  --crimson-dark: #A91324;
  --text-primary: #F5F6F7;
  --text-secondary: rgba(245, 246, 247, 0.68);
  --text-muted: rgba(245, 246, 247, 0.48);
  --border-subtle: rgba(255, 255, 255, 0.09);

  background: #07080a;
  border-top: 1px solid var(--border-subtle);
  color: var(--text-secondary);
  padding: 64px 0 24px;
  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, sans-serif;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.footer-logo-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-hex {
  width: 30px;
  height: 30px;
  background: linear-gradient(150deg, var(--crimson-light) 0%, var(--crimson) 55%, var(--crimson-dark) 100%);
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
}

.footer-logo-text {
  display: flex;
  flex-direction: column;
}

.logo-wrenzo-footer {
  font-family: 'Manrope', sans-serif;
  font-size: 1.3rem;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1;
  letter-spacing: -0.01em;
}

.logo-suite-footer {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 2.5px;
  color: var(--crimson-light);
  margin-top: 3px;
}

.footer-description {
  font-size: 0.9rem;
  line-height: 1.7;
  color: var(--text-muted);
  max-width: 320px;
}

.footer-heading {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: 0.02em;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-links a {
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  display: inline-block;
}

.footer-links a:hover {
  color: var(--crimson-light);
  transform: translateX(4px);
}

.footer-contact {
  font-size: 0.9rem;
}

.contact-item {
  display: flex;
  align-items: center;
}

.contact-item a {
  color: var(--text-secondary);
  text-decoration: none;
  word-break: break-all;
}

.contact-item a:hover {
  color: var(--crimson-light);
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.copyright {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.footer-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.85rem;
  color: var(--text-muted);
}

.meta-item {
  font-weight: 600;
}

.meta-divider {
  opacity: 0.5;
}

@media (max-width: 600px) {
  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>